import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Form, InputGroup } from "@themesberg/react-bootstrap";

const InputForm = ({
  id,
  label,
  icon,
  type,
  placeholder,
  handleChange,
  ...rest
}) => {
  return (
    <Form.Group id={id} className="mb-4">
      <Form.Label>{label}</Form.Label>
      <InputGroup>
        <InputGroup.Text>
          <FontAwesomeIcon icon={icon} />
        </InputGroup.Text>
        <Form.Control
          type={type}
          placeholder={placeholder}
          name={id}
          onChange={handleChange}
          {...rest}
        />
      </InputGroup>
    </Form.Group>
  );
};

export default InputForm;
